/**
 * Keyed by stored lowercase ids. The stored `google` id is the YouTube ad channel, so users
 * see "YouTube". Exact ids only: `facebook` and `instagram` stay unmapped, because relabelling
 * those sources "Meta" is a product decision nobody has made.
 */
const AD_PLATFORM_LABELS: Record<string, { key: string; fallback: string }> = {
  google: { key: "common.adPlatforms.youtube", fallback: "YouTube" },
  youtube: { key: "common.adPlatforms.youtube", fallback: "YouTube" },
  meta: { key: "common.adPlatforms.meta", fallback: "Meta" },
  tiktok: { key: "common.adPlatforms.tiktok", fallback: "TikTok" },
};

/**
 * Display label for a stored ad-platform id — the one place Meta, TikTok and YouTube are
 * named. An id this map does not know keeps the caller's own label, so each surface's
 * formatting of a new platform is unchanged.
 */
export function adPlatformLabel(
  t: (key: string, defaultValue: string) => string,
  platformId: string,
  fallbackLabel: string,
): string {
  const id = platformId.trim().toLowerCase();
  // Own keys only: an id like `constructor` must not resolve to an inherited Object member.
  const label = Object.hasOwn(AD_PLATFORM_LABELS, id) ? AD_PLATFORM_LABELS[id] : undefined;
  return label ? t(label.key, label.fallback) : fallbackLabel;
}
